import angular from 'angular';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { withProviders } from '../../../modules/core/components';
import growthbook from '../../../global/global.experiments';
import { TooltipTax } from '../../../modules/core/components/tax/tax';
import { FormattedMessage } from 'react-intl';
const InnerComponent = () => {
    return (<GrowthBookProvider growthbook={growthbook}>
      <div className={'price-excludes-tax'}>
        <FormattedMessage id="common.tax.pricing-excludes" defaultMessage="Pricing excludes tax"/>
        <TooltipTax />
      </div>
    </GrowthBookProvider>);
};
export default angular
    .module('doxy.common.components.reactPriceExcludesTax', [])
    .component('reactPriceExcludesTax', {
    template: `<div></div>`,
    controller: function ($element) {
        const render = () => {
            ReactDOM.render(React.createElement(withProviders(InnerComponent)), $element[0]);
        };
        this.$onChanges = _.debounce(render, 500);
    },
}).name;
